module.exports = __webpack_public_path__ + "static/media/1.9dd610e1.png";